export default "__VITE_ASSET__369eb249__"